import React from 'react';
import KeyMetricsWidget from '../dashboard/keyMetricsWidget';

function PerformanceWidget({
  cardType,
  params,
}: {
  cardType: string;
  params: any;
}) {
  const getWidget = () => {
    switch (cardType) {
      case 'lead_key_metrics':
        return <KeyMetricsWidget props={params} />;
      default:
        return null;
    }
  };
  return getWidget();
}

export default PerformanceWidget;
